import { fieldColourMapFrom, type FieldColourMap } from './fieldColourMap';
import committed from './fieldColourMap.json';

// tools/fields measures the painting offline (node tools/fields/run.mjs colour-map) and the build
// bundles what it wrote, so the app decodes no painting at load.
export function loadFieldColourMap(): FieldColourMap {
  return fieldColourMapFrom(committed);
}
